<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-select
              v-model="query.domainIds"
              multiple
              clearable
              placeholder="domains"
              filterable
              remote
              :loading="selectLoading"
              :remote-method="getDomains"
            >
              <el-option
                v-for="item in domains"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.taskIds"
              multiple
              clearable
              placeholder="tasks"
              filterable
              remote
              :loading="selectLoading"
              :remote-method="getTasks"
            >
              <el-option
                v-for="item in tasks"
                :key="item.id"
                :label="item.content"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="locale" @change="resetList">
              <el-option v-for="e in i18nConfig.locales" :key="e" :label="e" :value="e"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.status" @change="reGetList" clearable placeholder="上下架">
              <el-option label="上架" value="AVAILABLE"></el-option>
              <el-option label="下架" value="UNAVAILABLE"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.sortField"
              @change="reGetList"
              clearable
              placeholder="排序方式"
            >
              <el-option label="匹配评分" value="match_score"></el-option>
              <el-option label="质量评分" value="quality_score"></el-option>
              <el-option label="create_time" value="create_time"></el-option>
              <el-option label="update_time" value="update_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="query.sort" @change="reGetList" clearable placeholder="升降序">
              <el-option label="desc" value="desc"></el-option>
              <el-option label="asc" value="asc"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="query.title" @keyup.enter.native="reGetList" placeholder="title" />
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="query.toolId"
              filterable
              remote
              placeholder="工具筛选"
              :remote-method="(e) => toolRemoteMethod(e, true)"
              :loading="selectLoading"
              @change="reGetList"
            >
              <el-option
                v-for="item in filterTools"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="reGetList" type="primary">查询</el-button>
          <el-button @click="openDialog">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table ref="table" :data="list" v-loading="listLoading">
        <el-table-column align="center" prop="rank" width="120" label="rank"></el-table-column>
        <el-table-column align="center" prop="id" width="180" label="id"></el-table-column>
        <el-table-column
          align="center"
          prop="votesCount"
          width="140"
          label="投票数"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="qualityScore"
          width="140"
          label="质量分数"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="matchScore"
          width="140"
          label="匹配分数"
        ></el-table-column>
        <el-table-column align="center" label="title" prop="title" min-width="180" />
        <el-table-column align="center" label="createTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.createTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="updateTime" width="200">
          <template slot-scope="scope">
            {{ +scope.row.updateTime | filterTimeStamp }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="上下架" width="100" fixed="right">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="handleUpdate(scope.row)"
              active-value="AVAILABLE"
              inactive-value="UNAVAILABLE"
            />
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="260" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="postReUpdate(scope.row)"
              type="primary"
              size="mini"
              :loading="scope.row.loading"
              >更新</el-button
            >
            <el-button @click="openDialog(scope.row)" type="primary" size="mini"> 编辑 </el-button>
            <el-button @click="handleDelete(scope.row)" size="mini" type="danger"> 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.current"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <el-dialog :title="currentRow.id ? '编辑' : '新增'" :visible.sync="dialogVisible" width="800px">
      <div
        class="flex-container"
        style="margin-bottom: 10px; justify-content: flex-end"
        v-if="!currentRow.id"
      >
        <el-radio v-model="addType" label="LINK">链接新增</el-radio>
        <el-radio v-model="addType" label="FORM">表单新增</el-radio>
      </div>
      <el-form
        class="post-main-container post-dialog-container long"
        label-position="right"
        v-if="currentRow.id || addType === 'FORM'"
      >
        <el-form-item label="title：" required>
          <el-input v-model.trim="currentRow.title" />
        </el-form-item>
        <el-form-item label="originUrl：">
          <el-input v-model.trim="currentRow.originUrl" />
        </el-form-item>
        <el-form-item label="seoTitle：" required>
          <el-input v-model.trim="currentRow.seoTitle" />
        </el-form-item>
        <el-form-item label="seoDesc：" required>
          <el-input v-model.trim="currentRow.seoDesc" />
        </el-form-item>
        <el-form-item label="isFollowed：">
          <el-input type="number" v-model.number.trim="currentRow.isFollowed" />
        </el-form-item>
        <el-form-item label="votesBase：">
          <el-input v-model.number.trim="currentRow.votesBase" />
        </el-form-item>
        <el-form-item label="summary：">
          <div class="grid-box">
            <div
              :class="['point-box', { active: index === contentIndex }]"
              v-for="(e, index) in currentRow.summary"
              :key="index"
              @click="setActive(index)"
            >
              {{ index + 1 }}
            </div>
          </div>
          <div style="margin-bottom: 10px" v-if="currentRow.summary.length">
            <el-form-item label="title" required>
              <el-input v-model.trim="currentRow.summary[contentIndex].title" />
            </el-form-item>
            <el-form-item label="desc：" required>
              <el-input type="textarea" v-model="currentRow.summary[contentIndex].desc" />
            </el-form-item>
          </div>
          <el-button @click="addItem" size="mini">新增</el-button>
          <el-button @click="deleteItem" type="danger" size="mini">删除</el-button>
        </el-form-item>
        <el-form-item label="绑定工具：" required>
          <el-select
            v-model="selectToolForm.toolId"
            filterable
            remote
            placeholder="请输入 name"
            :remote-method="toolRemoteMethod"
            :loading="selectLoading"
            @change="onSelectTool"
          >
            <el-option v-for="item in tools" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="domains：">
          <el-select
            v-model="domainIds"
            multiple
            filterable
            remote
            :loading="selectLoading"
            :remote-method="getDomains"
          >
            <el-option
              v-for="item in domains"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="tasks：">
          <el-select
            v-model="taskIds"
            multiple
            filterable
            remote
            :loading="selectLoading"
            :remote-method="getTasks"
          >
            <el-option
              v-for="item in tasks"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="更新mode：">
          <el-radio v-model="currentRow.originData.mode" label="URL">链接</el-radio>
          <el-radio v-model="currentRow.originData.mode" label="TEXT">文本</el-radio>
        </el-form-item>
        <el-form-item label="更新链接：">
          <el-input v-model.trim="currentRow.originData.originUrl" />
        </el-form-item>
        <el-form-item label="更新文本：">
          <el-input type="textarea" v-model="currentRow.originData.originData" />
        </el-form-item>
        <el-form-item label="dataSource：" v-if="currentRow.dataSource">{{
          currentRow.dataSource
        }}</el-form-item>
        <el-form-item class="long" label="originLinkCount：" v-if="currentRow.originLinkCount">{{
          currentRow.originLinkCount
        }}</el-form-item>
        <el-form-item label="viewsCount：" v-if="currentRow.viewsCount">{{
          currentRow.viewsCount
        }}</el-form-item>
        <el-form-item label="votesCount：" v-if="currentRow.votesCount">{{
          currentRow.votesCount
        }}</el-form-item>
        <el-form-item label="评分详情：" v-if="currentRow.evaluationDetail">
          <div style="max-height: 500px; overflow-y: auto">
            <pre>
              {{ currentRow.evaluationDetail }}
            </pre>
          </div>
        </el-form-item>
        <el-form-item class="long" label="votesBaseCustomerService：">
          <el-input v-model.number.trim="currentRow.votesBaseCustomerService" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseDesignAndCreativity：">
          <el-input v-model.number.trim="currentRow.votesBaseDesignAndCreativity" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseEducationAndTraining：">
          <el-input v-model.number.trim="currentRow.votesBaseEducationAndTraining" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseFinance：">
          <el-input v-model.number.trim="currentRow.votesBaseFinance" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseHumanResources：">
          <el-input v-model.number.trim="currentRow.votesBaseHumanResources" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseInformationTechnology：">
          <el-input v-model.number.trim="currentRow.votesBaseInformationTechnology" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseLegal：">
          <el-input v-model.number.trim="currentRow.votesBaseLegal" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseManagement：">
          <el-input v-model.number.trim="currentRow.votesBaseManagement" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseMarketing：">
          <el-input v-model.number.trim="currentRow.votesBaseMarketing" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseOperations：">
          <el-input v-model.number.trim="currentRow.votesBaseOperations" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseResearchAndDevelopment：">
          <el-input v-model.number.trim="currentRow.votesBaseResearchAndDevelopment" />
        </el-form-item>
        <el-form-item class="long" label="votesBaseSales：">
          <el-input v-model.number.trim="currentRow.votesBaseSales" />
        </el-form-item>
      </el-form>
      <el-form class="post-main-container post-dialog-container long" label-position="right" v-else>
        <el-form-item label="link：" required>
          <el-input v-model.trim="link" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" :loading="btnLoading" @click="postEdit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLearnings,
  updateLearning,
  deleteLearning,
  saveLearningFromUrl,
  getTools,
  reUpdateLearning
} from '@/api/content'
import { getCategories } from '@/api/categories'
import { i18nConfig } from '@/utils'

const defaultRow = {
  summary: [],
  tools: [],
  title: '',
  originUrl: '',
  seoTitle: '',
  seoDesc: '',
  votesBase: '0',
  votesBaseCustomerService: '0',
  votesBaseDesignAndCreativity: '0',
  votesBaseEducationAndTraining: '0',
  votesBaseFinance: '0',
  votesBaseHumanResources: '0',
  votesBaseInformationTechnology: '0',
  votesBaseLegal: '0',
  votesBaseManagement: '0',
  votesBaseMarketing: '0',
  votesBaseOperations: '0',
  votesBaseResearchAndDevelopment: '0',
  votesBaseSales: '0',
  status: 'UNAVAILABLE',
  originData: {
    mode: 'URL',
    originData: '',
    originUrl: ''
  },
  isFollowed: 0
}

export default {
  data() {
    return {
      i18nConfig,
      locale: i18nConfig.defaultLocale,
      list: [],
      listTotal: null,
      listLoading: true,

      query: {
        sort: '',
        limit: 10,
        current: 1,
        domainIds: [],
        taskIds: [],
        sortField: '',
        toolId: '',
        title: ''
      },

      btnLoading: false,
      dialogVisible: false,
      currentRow: {},
      contentIndex: 0,
      link: '',

      domains: [],
      tasks: [],
      domainIds: [],
      taskIds: [],
      selectLoading: false,
      tools: [],
      filterTools: [],
      selectToolForm: {
        toolId: '',
        toolSlugName: ''
      },
      addType: 'LINK'
    }
  },

  mounted() {
    this.resetList()
  },

  methods: {
    postReUpdate(data) {
      const { id, title } = data
      const { mode, originData, originUrl } = data.originData
      if (!mode || (mode === 'URL' && !originUrl) || (mode === 'TEXT' && !originData)) {
        this.$message.error('请选择更新模式并填写相关更新字段')
        return
      }

      this.$confirm(`是否更新学习 ${title}`, '提示', {}).then(() => {
        data.loading = true
        reUpdateLearning(id, this.locale)
          .then(() => {
            this.getList()
          })
          .finally(() => {
            data.loading = false
          })
      })
    },

    onSelectTool(toolId) {
      const tool = this.tools.find((e) => e.id === toolId)
      this.selectToolForm.toolSlugName = tool.slugName
    },

    toolRemoteMethod(name, fromFilter = false) {
      this.selectLoading = true
      getTools({ name }, this.locale)
        .then((res) => {
          const tools = res.result.rows
          if (fromFilter) {
            this.filterTools = tools
          } else {
            this.tools = tools
          }
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    setActive(index) {
      this.contentIndex = index
    },

    deleteItem() {
      if (!this.currentRow.summary.length) return
      this.currentRow.summary.splice(this.contentIndex, 1)
      this.contentIndex = 0
    },

    addItem() {
      this.currentRow.summary.push({
        title: '',
        desc: ''
      })
      this.contentIndex = Math.max(this.currentRow.summary.length - 1, 0)
    },

    getDomains(content) {
      this.selectLoading = true
      getCategories(
        {
          content,
          auditStatus: 'APPROVED',
          status: 'AVAILABLE',
          type: 'DOMAIN'
        },
        this.locale
      )
        .then((res) => {
          this.domains = res.result.rows.filter((e) => e.slugName !== 'all-domains')
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    handleDelete(row) {
      const { id, title } = row
      this.$confirm(`是否删除学习"${title}"`, '提示', {}).then(() => {
        deleteLearning(id, this.locale).then(() => {
          this.getList()
        })
      })
    },

    getTasks(content) {
      this.selectLoading = true
      getCategories(
        {
          content,
          auditStatus: 'APPROVED',
          status: 'AVAILABLE',
          type: 'TASK'
        },
        this.locale
      )
        .then((res) => {
          this.tasks = res.result.rows.filter((e) => e.slugName !== 'all-tasks')
        })
        .finally(() => {
          this.selectLoading = false
        })
    },

    checkFormFull() {
      if (this.addType === 'LINK' && !this.currentRow.id) {
        if (!this.link) {
          this.$message.error('请填写必填项')
          return false
        }
        return true
      }
      const { toolId, toolSlugName } = this.selectToolForm
      const { title, seoTitle, seoDesc, summary } = this.currentRow
      if ([title, seoTitle, seoDesc, toolId, toolSlugName].includes('')) {
        this.$message.error('请填写必填项')
        return false
      }

      const idx = summary.findIndex((e) => !e.title || !e.desc)
      if (idx !== -1) {
        this.$message.error(`请填写 summary 第${idx + 1}项`)
        return false
      }

      return true
    },

    postEdit() {
      if (!this.checkFormFull()) return

      if (this.addType === 'LINK' && !this.currentRow.id) {
        this.btnLoading = true
        saveLearningFromUrl(this.link, this.locale)
          .then(() => {
            this.dialogVisible = false
            this.getList()
          })
          .finally(() => {
            this.btnLoading = false
          })
      } else {
        const metaTagRelations = this.domainIds
          .concat(this.taskIds)
          .map((id) => ({ metaTagId: id }))
        const learnToolRelations = [this.selectToolForm]
        const form = JSON.parse(JSON.stringify(this.currentRow))
        this.btnLoading = true
        form.summary = JSON.stringify(form.summary)
        form.metaTagRelations = metaTagRelations
        form.learnToolRelations = learnToolRelations
        this.handleUpdate(form)
          .then(() => {
            this.dialogVisible = false
          })
          .finally(() => {
            this.btnLoading = false
          })
      }
    },

    handleUpdate(row) {
      return new Promise((resolve, reject) => {
        updateLearning(row, this.locale)
          .then(() => {
            this.getList()
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },

    openDialog(row) {
      this.link = ''
      this.contentIndex = 0
      this.selectToolForm.toolId = ''
      this.selectToolForm.toolSlugName = ''
      this.addType = 'LINK'
      this.tools = []
      if (row.id) {
        this.domainIds = row.domains.map((e) => e.id)
        this.taskIds = row.tasks.map((e) => e.id)
        this.currentRow = JSON.parse(JSON.stringify(row))
        this.domains = this.currentRow.domains
        this.tasks = this.currentRow.tasks
        this.currentRow.summary = JSON.parse(this.currentRow.summary || '[]')
      } else {
        this.domainIds = []
        this.taskIds = []
        this.currentRow = JSON.parse(JSON.stringify(defaultRow))
      }
      const [tool] = this.currentRow.tools
      if (tool) {
        this.selectToolForm.toolId = tool.id
        this.selectToolForm.toolSlugName = tool.slugName
        this.tools = [tool]
      }
      this.dialogVisible = true
    },

    reGetList() {
      this.query.current = 1
      this.getList()
    },

    resetList() {
      this.query.domainIds = []
      this.query.taskIds = []
      this.reGetList()
      this.domains = []
      this.tasks = []
    },

    getList() {
      this.listLoading = true
      const form = JSON.parse(JSON.stringify(this.query))
      if (!form.sortField) {
        delete form.sortField
      }
      if (!form.sort) {
        delete form.sort
      }
      getLearnings(form, this.locale).then((res) => {
        this.list = res.result.rows.map((e) => {
          let evaluationDetail = ''
          try {
            const jsonObject = JSON.parse(e.evaluationDetail || '{}')
            evaluationDetail = JSON.stringify(jsonObject, null, 4)
          } catch (error) {
            console.log(error)
          }
          return {
            ...e,
            evaluationDetail,
            originData: e.originData || {
              mode: 'URL',
              originData: '',
              originUrl: ''
            },
            loading: false
          }
        })
        this.listTotal = +res.result.total
        this.listLoading = false
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.reGetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-box {
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 10px;
}

.point-box {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  border: 1px solid #006fff;

  &.active {
    background-color: #006fff;
    color: #fff;
  }
}
</style>
